import http from '../http'

const API_URL = 'document-controls'

class DocumentControlAPI {
  /** Listado de formatos con el código y versión vigentes para la empresa. */
  async list(companyId) {
    return await http(`${API_URL}/${companyId}`)
  }

  /** Guarda el código y, la primera vez, el punto de partida de la versión. */
  async upsert(companyId, documentType, payload) {
    return await http(`${API_URL}/${companyId}/${documentType}`, 'PUT', payload)
  }

  /** Avanza el consecutivo de versión y sella la fecha de aprobación. */
  async newVersion(companyId, documentType) {
    return await http(`${API_URL}/${companyId}/${documentType}/new-version`, 'POST')
  }
}

export default new DocumentControlAPI()
